import React, { useState } from 'react'

import { useMapi, useUser } from '@leshen/gatsby-theme-leshen'
import { Form } from '@leshen/ui'
import AvailabilitySubmissionMessage from './AvailabilitySubmissionMessage'
import defaultAvailabilitySubmit from './availabilitySubmit'

const Availability = ({
  label = null,
  buttonText = 'Find',
  buttonColor = 'primary',
  buttonOutlined = false,
  handleSubmit = defaultAvailabilitySubmit,
  placeholderText = '',
  buttonGradient = false,
  setShowModal = null,
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false)
  const { setZipLocation, isLoading, setUserData } = useUser()
  const { sessionPromoCode, requestId } = useMapi()

  const zipField = [
    {
      label,
      name: 'zip_postal',
      value: '',
      required: true,
      type: 'text',
      placeholderText,
    },
  ]

  return (
    <>
      <Form
        inlineButton
        submitButtonGradient={buttonGradient}
        formSource="static"
        fields={zipField}
        submitButtonText={buttonText}
        submitButtonColor={buttonColor}
        submitButtonOutlined={buttonOutlined}
        onSubmit={({ values }) => {
          if (setShowModal) {
            setShowModal(false)
          }
          setZipLocation(values.zip_postal)
          handleSubmit({
            values,
            setIsSubmitted,
            setUserData,
            sessionPromoCode,
            requestId,
          })
        }}
      />
      {isSubmitted && !isLoading && <AvailabilitySubmissionMessage />}
    </>
  )
}

export default Availability
